export default __webpack_public_path__ + "static/media/phivolcs_seal.7be0e61f.png";